<template>
  <div class="app-activation-wrapper">
    <slot name="txtBefore"></slot>
    <!-- SIM aktivieren -->
    <div class="activation-info overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderActivationInfo">SIM-Karte aktivieren</slot>
        <b-btn @click="goToStep(infoStepName)" class="accordion-toggle" v-if="editButtonInfo">zurück</b-btn>
      </div>
      <b-collapse v-model="openInfo">
        <ActivationInfo :activation-code-min="4"
                        :activation-code-max="5"
                        :next-step="productsStepName"
        >
          <template v-for="slot in possibleChildSlotsFor('Info')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationInfo>
      </b-collapse>
    </div>
    <!-- Dateneingabe Modal -->
    <div class="activation-info-modal">
      <ActivationInfoModal :next-step="productsStepName">
        <template v-for="slot in possibleChildSlotsFor('InfoModal')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ActivationInfoModal>
    </div>
    <!-- Tarif-Pakete -->
    <div class="activation-products overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderProducts">Tarif-Pakete buchen</slot>
        <b-btn @click="goToStep(productsStepName)" class="accordion-toggle" v-if="editButtonProducts">zurück</b-btn>
      </div>
      <b-collapse v-model="openProducts">
        <ActivationProducts :next-step="'topUp'" v-if="openProducts" :tariffs-extra="extraData_">
          <template v-for="slot in possibleChildSlotsFor('Products')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationProducts>
      </b-collapse>
    </div>
    <!-- Aufladung -->
    <div class="activation-top-up overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderTopUp">Aufladung einrichten</slot>
        <b-btn @click="goToStep(topUpStepName)" class="accordion-toggle" v-if="editButtonTopUp">zurück</b-btn>
      </div>
      <b-collapse v-model="openTopUp">
        <ActivationTopUp :next-step="personalDataStepName" v-if="openTopUp">
          <template v-for="slot in possibleChildSlotsFor('TopUp')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationTopUp>
      </b-collapse>
    </div>
    <!-- Persönliche Daten -->
    <div class="activation-personal-data overview-process" v-if="!showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderPersonalData">Persönliche Daten</slot>
        <b-btn @click="goToStep(personalDataStepName)" class="accordion-toggle" v-if="editButtonPersonalData">zurück</b-btn>
      </div>
      <b-collapse v-model="openPersonalData">
        <ActivationPersonalData :next-step="nextStepPersonalData">
          <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationPersonalData>
      </b-collapse>
    </div>
    <!-- Zahldaten -->
    <div class="activation-payment overview-process" v-if="!showSuccess && showPayment">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderPayment">Zahldaten</slot>
        <b-btn @click="goToStep(paymentStepName)" class="accordion-toggle" v-if="editButtonPayment">zurück</b-btn>
      </div>
      <b-collapse v-model="openPayment">
        <ActivationPayment
          :nextStep="summaryStepName"
          :credit-card-frame-address="creditCardFrameAddress"
          :credit-card-redirect-url="creditCardRedirectUrl"
        >
          <template v-for="slot in possibleChildSlotsFor('ActivationPayment')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationPayment>
      </b-collapse>
    </div>
    <!-- Success -->
    <div class="activation-success overview-process" v-if="showSuccess">
      <div class="accordion-header">
        <slot name="txtAccordionHeaderSuccess">success</slot>
      </div>
      <b-collapse v-model="openSuccess">
        <ActivationSuccess
          :slotData="deferredResponse"
          :show-print-preview-button="false"
        >
          <template v-for="slot in possibleChildSlotsFor('Success', (getSuccessIdent.charAt(0).toUpperCase() + getSuccessIdent.slice(1)))" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationSuccess>
      </b-collapse>
    </div>
    <!-- Zusammenfassung -->
    <div class="activation-summary overview-process">
      <div class="accordion-header" v-if="!showSuccess">
        <slot name="txtAccordionHeaderSummary">Zusammenfassung</slot>
        <b-btn @click="goToStep(summaryStepName)" class="accordion-toggle" v-if="editButtonSummary">zurück</b-btn>
      </div>
      <div class="accordion-header" v-else>
        <slot name="txtAccordionHeaderSummarySuccess">Zusammenfassung</slot>
      </div>
      <b-collapse v-model="openSummary">
        <ActivationSummary :nextStep="'success'" v-if="openSummary" :extra="extraData_">
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ActivationSummary>
      </b-collapse>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import extraData from '@/mixins/extraData'
import slotProxy from '@/mixins/slotProxy'
import ActivationInfo, { stepName as infoStepName } from '@/components/process/FYVE/Activation/Info/ActivationInfo.vue'
import ActivationProducts, { stepName as productsStepName } from '@/components/process/FYVE/Activation/Tariff/Products.vue'
import ActivationTopUp, { stepName as topUpStepName } from '@/components/process/FYVE/Activation/Wrapper/TopUp.vue'
import ActivationPersonalData, { stepName as personalDataStepName } from '@/components/process/FYVE/Activation/PersonalData/PersonalData.vue'
import ActivationPayment, { stepName as paymentStepName } from '@/components/process/FYVE/Activation/Payment/Payment.vue'
import ActivationSummary, { stepName as summaryStepName } from '@/components/process/FYVE/Activation/Wrapper/ActivationSummaryWrapper.vue'
import ActivationSuccess, { stepName as successStepName } from '@/components/process/FYVE/Activation/Success/fyve/Success.vue'
import ActivationInfoModal from '@/components/process/FYVE/Activation/Info/ActivationInfoModal.vue'

const computedAccordionOpen = function (stepName) {
  return {
    get () {
      if (this.currentStep === 'success' && stepName === 'summary') {
        return true
      }
      return this.currentStep === stepName
    },
    set () {} // dummy setter for v-model bind
  }
}

const computedEditButton = function (stepName) {
  return {
    get () {
      return processSteps.indexOf(this.currentStep) > processSteps.indexOf(stepName)
    }
  }
}

const processSteps = [infoStepName, productsStepName, topUpStepName, personalDataStepName, paymentStepName, summaryStepName, successStepName]
export default {
  name: 'ActivationWrapper',
  data () {
    return {}
  },
  import: {
    infoStepName,
    productsStepName,
    topUpStepName,
    personalDataStepName,
    paymentStepName,
    summaryStepName
  },
  components: {
    ActivationPayment,
    ActivationSummary,
    ActivationPersonalData,
    ActivationTopUp,
    ActivationProducts,
    ActivationInfo,
    ActivationInfoModal,
    ActivationSuccess
  },
  computed: {
    ...mapGetters([
      'brand'
    ]),
    ...mapGetters('activation', {
      currentStep: 'showActivationView'
    }),
    ...mapGetters('activation/topUp', [
      'hasTopUp'
    ]),
    ...mapGetters('activation/submit', [
      'getSuccessIdent',
      'deferredResponse'
    ]),
    // open status for accordions
    openInfo: computedAccordionOpen.bind(this)(infoStepName),
    openProducts: computedAccordionOpen.bind(this)(productsStepName),
    openTopUp: computedAccordionOpen.bind(this)(topUpStepName),
    openPersonalData: computedAccordionOpen.bind(this)(personalDataStepName),
    openPayment: computedAccordionOpen.bind(this)(paymentStepName),
    openSummary: computedAccordionOpen.bind(this)(summaryStepName),
    openSuccess: computedAccordionOpen.bind(this)(successStepName),
    // show show process step at all (e.g. payment)
    showPayment: function () {
      // payment is shown when we have not yet processed the top up step
      if (processSteps.indexOf(this.currentStep) <= processSteps.indexOf(topUpStepName)) {
        return true
      }
      // or later, if we decided in favor of topup
      return this.hasTopUp
    },
    showSuccess: computedAccordionOpen.bind(this)(successStepName),
    // show edit buttons for steps
    editButtonInfo: () => false,
    editButtonProducts: computedEditButton.bind(this)(productsStepName),
    editButtonTopUp: computedEditButton.bind(this)(topUpStepName),
    editButtonPersonalData: computedEditButton.bind(this)(personalDataStepName),
    editButtonPayment: computedEditButton.bind(this)(paymentStepName),
    editButtonSummary: computedEditButton.bind(this)(summaryStepName),
    // special step handling
    nextStepPersonalData: function () {
      if (this.hasTopUp) {
        return 'payment'
      }
      return 'summary'
    },
    extraData_: function () {
      return this.extraData
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ])
  },
  mixins: [
    transaction('activation'),
    extraData(),
    slotProxy()
  ],
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
